import { useMemo } from "react";
import FacilityCard from "./FacilityCard";
import "../css/homepage.css";

const FacilityList = ({ facilityData }) => {

  const sortedFacilities = useMemo(() => {
    if (!Array.isArray(facilityData)) return [];



    return [...facilityData].sort((a, b) =>
      a.facility_name?.localeCompare(b.facility_name)
    );
  }, [facilityData]);

  return (
    <div className="facility-list">
      <div className="facility-list-wrap">
        {sortedFacilities.map((item) => (
          <FacilityCard key={item.facility_id} data={item} />
        ))}
      </div>
    </div>
  );
};

export default FacilityList;
